import { isArray, isNumber, isBoolean, isString, isPlainObject } from 'lodash';

/**
 * Converts given data to FormData instance.
 *
 * @param    {object}    data  Data to convert.
 * @returns  {FormData}        Converted data.
 */
export const convertToFormData = (data, { skipEmpty = false } = {}) => {
    const formData = new FormData();

    for (const key in data) {
        let value = data[key];

        // FormData by default converts each value to string, so bool
        // values are converted to 'true' and 'false'. To override this
        // behavior we have to cast this values to int.
        if (isBoolean(value)) {
            value = value ? 1 : 0;
        }

        // FormData by default converts each value to string, so null
        // becames 'null'. To override this behavior we have to set this
        // values to empty string.
        if (null === value || undefined === value) {
            value = '';
        }

        // Skip empty values if "skipEmpty" option is given.
        if (skipEmpty) {
            if ((isArray(value) || isString(value)) && 0 === value.length) {
                continue;
            }

            if (! isNumber(value) && ! value) {
                continue;
            }
        }

        /**
         * Convert array values to format recogniseable by PHP.
         *
         * key: [1, 2] becomes key[]: 1, key[]: 2
         */
        if (isArray(value)) {
            value.forEach((v) => {
                formData.append(`${key}[]`, v);
            });

            continue;
        }

        /**
         * Convert plain object values to format recogniseable by PHP.
         *
         * key: {a: 1, b: 2} becomes key[a]: 1, key[b]: 2
         */
        if (isPlainObject(value)) {
            for (const k in value) {
                const v = value[k];
                formData.append(`${key}[${k}]`, v);
            }

            continue;
        }

        formData.append(key, value);
    }

    return formData;
};
